import { Modal } from '@mantine/core'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { UpdatedFacilitiesScreen } from '../../facilities/updated-facilities-screen'
import PrimaryInput from 'app/views/components/buttons/PrimaryInput'
import { CustomLoaderPage } from 'app/views/components/loader/loader-page'
import { loadFacilityFormLists } from 'app/state/utils/form-lists'

function CreateFacilityButton() {
  const dispatch = useDispatch()
  const [openFacility, setOpenFacility] = useState(false)
  const [loading, setLoading] = useState(false)

  // The form builds its dropdowns once, from the store, so its lists are in
  // before it mounts: the modal shows a loader until they are.
  async function openForm() {
    setLoading(true)
    setOpenFacility(true)
    try {
      await dispatch(loadFacilityFormLists() as any)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <PrimaryInput text="Create Facility" onClick={() => openForm()} />
      <Modal
        className="modal-body modal-body-template fit-content-modal"
        opened={openFacility}
        onClose={() => setOpenFacility(false)}
        centered={true}
        size="77%"
      >
        {loading ? (
          <CustomLoaderPage />
        ) : (
          <UpdatedFacilitiesScreen
            deal={undefined}
            facility={undefined}
            onClose={() => setOpenFacility(false)}
          />
        )}
      </Modal>
    </>
  )
}

export default CreateFacilityButton
